import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "status"]

  async register() {
    this.statusTarget.textContent = "Starting registration..."
    this.statusTarget.className = "text-sm text-slate-500 mt-4"

    try {
      // Get creation options from server
      const optionsResponse = await fetch("/admin/passkeys/create_options", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })
      const options = await optionsResponse.json()

      // Decode challenge and user ID from base64url
      options.challenge = this.base64urlToBuffer(options.challenge)
      options.user.id = this.base64urlToBuffer(options.user.id)
      if (options.excludeCredentials) {
        options.excludeCredentials = options.excludeCredentials.map(cred => ({
          ...cred,
          id: this.base64urlToBuffer(cred.id)
        }))
      }

      this.statusTarget.textContent = "Touch your fingerprint or use Face ID..."

      // Create credential via browser API
      const credential = await navigator.credentials.create({ publicKey: options })

      // Send credential to server
      const createResponse = await fetch("/admin/passkeys", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          label: this.labelTarget.value || "",
          credential: {
            id: credential.id,
            rawId: this.bufferToBase64url(credential.rawId),
            type: credential.type,
            response: {
              attestationObject: this.bufferToBase64url(credential.response.attestationObject),
              clientDataJSON: this.bufferToBase64url(credential.response.clientDataJSON)
            }
          }
        })
      })

      const result = await createResponse.json()

      if (result.status === "ok") {
        this.statusTarget.textContent = "Passkey registered. Reloading..."
        this.statusTarget.className = "text-sm text-green-600 mt-4"
        setTimeout(() => window.location.reload(), 1000)
      } else {
        this.statusTarget.textContent = `Error: ${result.error}`
        this.statusTarget.className = "text-sm text-red-600 mt-4"
      }
    } catch (e) {
      this.statusTarget.textContent = e.name === "NotAllowedError"
        ? "Registration cancelled."
        : `Error: ${e.message}`
      this.statusTarget.className = "text-sm text-red-600 mt-4"
    }
  }

  base64urlToBuffer(base64url) {
    const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/")
    const padded = base64 + "=".repeat((4 - base64.length % 4) % 4)
    const binary = atob(padded)
    return Uint8Array.from(binary, c => c.charCodeAt(0)).buffer
  }

  bufferToBase64url(buffer) {
    const bytes = new Uint8Array(buffer)
    let binary = ""
    bytes.forEach(b => binary += String.fromCharCode(b))
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
  }
}
